interface ArrowRightIconProps {
	iconColor?: string;
	width?: string;
	height?: string;
}
const LinkIcon = ({ iconColor = '#212529', width = '24', height = '24' }: ArrowRightIconProps) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.0503 16.9496L16.9498 7.05014M16.9498 7.05014L16.9498 14.4748M16.9498 7.05014L9.52518 7.05014"
			stroke={iconColor}
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default LinkIcon;
